module.exports = __webpack_public_path__ + "static/media/time_icon.a44624df.png";